import { updateUserConfigurationAndService } from "owa-userconfiguration/lib/utils/updateUserConfigurationAndService";

export function updatePontTypeValue(pontValue: number): void {
    updateUserConfigurationAndService({
        UserOptions: {
            NewEnabledPonts: pontValue,
        },
    });
}
